import { appActions } from '@app';
import { useAction } from '@hooks';
export function usePeriscopeReset() {
    return useAction(appActions.resetPeriscope);
}
